module.exports = __webpack_public_path__ + "img/sld_abt_check_light.46b6e9c3.svg";